module.exports = __webpack_public_path__ + "media/images/icons/map/marker-passenger-10b68f48368ce456fcbc8b1c152020dd.svg";